<!-- Responsibility: List and manage saved game scenarios.
Scope: Owns save data fetching and selection triggers. -->
<saves-view class="menu-section active menu-overlay">
  <h3 class="lobby-section-title">GAME SAVES (SCENARIOS)</h3>
  
  <div class="save-list">
    <p if={ state.loading && !state.saves.length } class="lobby-hint">Scanning registry...</p>
    <p if={ state.error } class="lobby-error">Error accessing registry.</p>
    <p if={ !state.loading && !state.error && !state.saves.length } class="lobby-hint">No realities stored.</p>

    <div if={ state.loading && !state.saves.length } class="loading-stack" aria-busy="true">
      <save-slot-card each={ _ in LOADING_ROWS } loading={ true }></save-slot-card>
    </div>
    
    <save-slot-card
      each={ save in state.saves }
      save={ save }
      loading={ state.loadingSaveId === save.id }
      on-select={ (id) => loadSave(id) }
      on-delete={ (id) => deleteSave(id) }
    ></save-slot-card>
  </div>

  <a class="nav-link" onclick={ goHub }>← BACK TO HUB</a>

  <script>
    import SaveSlotCard from '../components/lobby/save-slot-card.riot'
    import { persistenceService } from '../../services/persistence-service.ts'
    import { navigateState, sysNotify } from '../../app-states.js'

    const LOADING_ROWS = [0, 1, 2, 3]

    export default {
      components: { SaveSlotCard },
      state: {
        saves: [],
        loading: true,
        error: false,
        loadingSaveId: null,
      },

      onMounted() {
        this.loadSaves()
      },

      async loadSaves() {
        this.update({ loading: true, error: false, saves: [] })
        try {
          const saves = await persistenceService.listSaves()
          this.update({ saves, loading: false })
        } catch {
          this.update({ loading: false, error: true })
        }
      },

      async loadSave(id) {
        if (!id || this.state.loadingSaveId) return
        this.update({ loadingSaveId: id })
        sysNotify('Restoring reality...')
        try {
          await persistenceService.restoreSave(id)
          navigateState('scene', id)
        } catch (e) {
          sysNotify('Failed to load save.')
          this.update({ loadingSaveId: null })
        }
      },

      async deleteSave(id) {
        if (!id) return
        const previousSaves = [...this.state.saves]
        this.update({
          saves: previousSaves.filter(save => save.id !== id),
          loading: false,
          error: false,
        })
        try {
          await persistenceService.deleteSave(id)
          sysNotify('Reality erased.')
        } catch (e) {
          this.update({ saves: previousSaves })
          sysNotify('Delete failed.')
        }
      },

      goHub() {
        navigateState('hub')
      }
    }
  </script>

  <style>
    saves-view {
      display: flex;
      flex-direction: column;
      gap: var(--space-lg);
      width: 100%;
      max-width: min(100%, 78rem);
    }

    .lobby-section-title {
      color: var(--text-muted);
      font-size: 0.92rem;
      letter-spacing: 0.14em;
      border-bottom: 1px solid var(--border);
      padding-bottom: var(--space-sm);
      margin: 0;
    }

    .lobby-hint {
      color: var(--text-dim);
      font-size: var(--space-md);
      line-height: 1.45;
    }

    .lobby-error {
      color: var(--danger);
    }

    .save-list {
      display: flex;
      flex-direction: column;
      gap: 0.625rem;
      max-height: 50vh;
      overflow-y: auto;
    }
  </style>
</saves-view>
